import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ChatInterface from './components/ChatInterface';
import FormIntake from './components/FormIntake';
import LinktreeLanding from './components/LinktreeLanding';
import GamesMenu from './components/GamesMenu';
import GreenFlagRedFlag from './components/GreenFlagRedFlag';
import AdminPanel from './components/AdminPanel';
import './styles/App.css';

function AppContent() {
  const location = useLocation();
  const isChatPage = location.pathname === '/sign-in' || location.pathname === '/chat';

  return (
    <div className={`App ${isChatPage ? 'chat-page' : ''}`}>
      <Routes>
        <Route path="/" element={<LinktreeLanding />} />
        <Route path="/sign-in" element={<FormIntake />} />
        <Route path="/chat" element={<ChatInterface />} />
        <Route path="/games" element={<GamesMenu />} />
        <Route path="/games/green-flag-red-flag/:eventId" element={<GreenFlagRedFlag />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </div>
  );
}

function App() {
  useEffect(() => {
    /* eslint-disable */
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window,document,"clarity","script","vus54topre");
    /* eslint-enable */
  }, []);

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
